import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ModernLayout from '../components/modern_layout';
import ModernLoader from '../components/modern_loader';
import { useGlobalToast } from '../components/modern_toast';
import usePageTitle from '../hooks/usePageTitle';
import api from '../services/api';

function ModernTrocarSenha() {
  const history = useHistory();
  const { addToast } = useGlobalToast();
  usePageTitle('Trocar Senha');

  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    senha: '',
    senhaConfirmar: ''
  });
  const [errors, setErrors] = useState({
    senha: false,
    senhaConfirmar: false
  });

  useEffect(() => {
    const verificarLogin = async () => {
      try {
        setLoading(true);

        // Verificar se o usuário está logado
        const login = sessionStorage.getItem('login');
        if (!login) {
          addToast('Você precisa estar logado para acessar esta página', 'error');
          history.push('/?id=' + sessionStorage.getItem('loja'));
          return;
        }

        // Se for franqueado, verificar loja
        if (login.includes('/')) {
          const params = new URLSearchParams(window.location.search);
          const lojaParam = params.get('loja');
          const lojaSession = sessionStorage.getItem('loja');

          if (lojaParam !== lojaSession) {
            history.push('/trocar_senha?loja=' + lojaSession);
            return;
          }

          // Verificar login no servidor
          try {
            const response = await api.post('verificar_login', {
              id_loja: lojaSession,
              login: login
            });

            if (response.data && !response.data.login) {
              if (response.data.id) {
                sessionStorage.setItem('loja', response.data.id);
                history.push('/trocar_senha?loja=' + response.data.id);
                return;
              }
            }
          } catch (error) {
            console.error('Erro ao verificar login:', error);
            addToast('Erro ao verificar login', 'error');
          }
        }

        setLoading(false);
      } catch (error) {
        console.error('Erro ao carregar página:', error);
        addToast('Erro ao carregar página', 'error');
        setLoading(false);
      }
    };

    verificarLogin();
  }, [history, addToast]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Limpar erro ao digitar
    setErrors(prev => ({
      ...prev,
      [name]: false
    }));
  };

  const validateForm = () => {
    const newErrors = {
      senha: false,
      senhaConfirmar: false
    };

    let isValid = true;

    // Verificar se os campos estão vazios
    if (!formData.senha) {
      newErrors.senha = true;
      isValid = false;
    }

    if (!formData.senhaConfirmar) {
      newErrors.senhaConfirmar = true;
      isValid = false;
    }

    // Verificar se as senhas são iguais
    if (formData.senha && formData.senhaConfirmar && formData.senha !== formData.senhaConfirmar) {
      newErrors.senha = true;
      newErrors.senhaConfirmar = true;
      isValid = false;
      addToast('As senhas não coincidem', 'error');
    }

    // Verificar comprimento mínimo
    if (formData.senha && formData.senha.length < 6) {
      newErrors.senha = true;
      isValid = false;
      addToast('A senha deve ter no mínimo 6 caracteres', 'error');
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setIsSubmitting(true);
      const login = sessionStorage.getItem('login');

      // Verificar se é franqueado ou cliente
      if (login.includes('/')) {
        // Trocar senha de franqueado
        await api.post('trocar_senha', {
          senha: formData.senha,
          login: login
        });
        addToast('Senha alterada com sucesso!', 'success');
      } else {
        // Trocar senha de cliente
        await api.post('trocar_senha_usuario', {
          senha: formData.senha,
          login: login
        });
        addToast('Senha alterada com sucesso!', 'success');
      }

      // Redirecionar para home após trocar senha
      setTimeout(() => {
        history.push('/?id=' + sessionStorage.getItem('loja'));
      }, 1500);

    } catch (error) {
      console.error('Erro ao trocar senha:', error);
      addToast('Erro ao trocar senha. Tente novamente.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return <ModernLoader message="Carregando..." />;
  }

  return (
    <ModernLayout title="Trocar Senha" showBackButton={true}>
      <div className="container mt-4">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            {/* Card principal */}
            <div className="modern-card p-4 mb-4">
              <p className="text-muted text-center mb-4">
                <i className="bi bi-shield-lock me-2 text-primary"></i>
                Preencha os campos abaixo para alterar sua senha
              </p>

              <form onSubmit={handleSubmit}>
                {/* Campo Senha */}
                <div className="mb-3">
                  <label htmlFor="senha" className="form-label fw-semibold">
                    Nova Senha
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-lock"></i>
                    </span>
                    <input
                      type="password"
                      className={`form-control ${errors.senha ? 'is-invalid' : ''}`}
                      id="senha"
                      name="senha"
                      value={formData.senha}
                      onChange={handleChange}
                      placeholder="Digite sua nova senha"
                      autoComplete="new-password"
                    />
                    {errors.senha && (
                      <div className="invalid-feedback">
                        Senha inválida
                      </div>
                    )}
                  </div>
                  <small className="text-muted">
                    A senha deve ter no mínimo 6 caracteres
                  </small>
                </div>

                {/* Campo Confirmar Senha */}
                <div className="mb-4">
                  <label htmlFor="senhaConfirmar" className="form-label fw-semibold">
                    Confirmar Nova Senha
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-lock-fill"></i>
                    </span>
                    <input
                      type="password"
                      className={`form-control ${errors.senhaConfirmar ? 'is-invalid' : ''}`}
                      id="senhaConfirmar"
                      name="senhaConfirmar"
                      value={formData.senhaConfirmar}
                      onChange={handleChange}
                      placeholder="Confirme sua nova senha"
                      autoComplete="new-password"
                    />
                    {errors.senhaConfirmar && (
                      <div className="invalid-feedback">
                        As senhas não coincidem
                      </div>
                    )}
                  </div>
                </div>

                {/* Botão de submissão */}
                <button
                  type="submit"
                  className="btn btn-modern w-100"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Alterando senha...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-circle me-2"></i>
                      Confirmar alteração
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* Card de dicas */}
            <div className="modern-card p-3">
              <h6 className="fw-bold mb-2">
                <i className="bi bi-info-circle me-2 text-info"></i>
                Dicas de segurança
              </h6>
              <ul className="small text-muted mb-0">
                <li>Use uma senha forte com letras, números e caracteres especiais</li>
                <li>Não compartilhe sua senha com outras pessoas</li>
                <li>Evite usar a mesma senha em diferentes serviços</li>
                <li>Troque sua senha periodicamente</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ModernLayout>
  );
}

export default ModernTrocarSenha;
